import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import {
  BodyLarge,
  BodyLargeMedium,
  BodyRegular,
  BodyRegularMedium,
  BodySmall,
  BodySmallMedium,
} from '@src/fonts/typography/Typography';
import { device } from '@src/common/breakpoints';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const AlertHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #976700;

  svg {
    flex-shrink: 0;
    color: #976700;
    width: 20px;
    height: 20px;

    ${device.smallTablet} {
      width: 24px;
      height: 24px;
    }
  }
`;

export const SummaryContent = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  border-radius: 4px;
  background: ${LayoutColors.whiteDark};
`;

export const SummaryProductInfo = styled.div`
  display: flex;
  padding-bottom: 16px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  flex-direction: column;

  border-bottom: 1px solid ${LayoutColors.grayMain};

  ${device.smallTablet} {
    flex-direction: row;
  }
`;

export const SummaryProductInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
`;

export const ProductName = styled.div`
  ${BodyLargeMedium};
  color: ${LayoutColors.blackMain};
  font-weight: 600;
`;

export const SummaryScheduleInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SummaryProductInfoContentItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;

  span {
    ${BodyRegular};
    color: ${LayoutColors.blackMain};
  }

  svg {
    flex-shrink: 0;
    color: ${LayoutColors.blackMain};
  }
`;

export const TotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const TotalItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const DisclaimerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;

  svg {
    flex-shrink: 0;
    color: ${LayoutColors.blackMain};
  }

  ${device.smallTablet} {
    align-items: center;
  }
`;

export const DisclaimerContent = styled.div`
  ${BodySmallMedium}
  color: ${LayoutColors.blackMain};
  font-weight: 600;
`;

export const AlertTitle = styled.h3`
  ${BodySmallMedium};
  color: #976700;
  font-weight: 600;
  flex: 1 0 0;

  ${device.smallTablet} {
    ${BodyRegularMedium};
    color: inherit;
    font-weight: 600;
  }
`;

export const AlertContent = styled.p`
  ${BodySmall};
  color: #976700;
  line-height: normal;

  align-self: stretch;
`;

export const OriginalAmount = styled.p`
  ${BodyRegular};
  color: ${LayoutColors.blackLight};
`;

export const NewAmount = styled.p`
  ${BodyRegular};
  color: ${LayoutColors.blackMain};
`;

export const TotalToPayLabel = styled.p`
  ${BodyLarge};
  color: ${LayoutColors.blackMain};
`;

export const TotalToPayValue = styled.p`
  ${BodyLargeMedium};
  color: ${LayoutColors.blackMain};
  font-weight: 600;
`;
